import AppEvents from 'Shared/app-events';
import Aside from './aside';
import Bloodhound from 'bloodhound';
import 'typeahead';

import SearchApi from 'Api/search-api';
import MediaApi from 'Api/media-api';

export default class SearchModule extends Aside {
    constructor(view, options = {
        id: 'search-panel'
    }) {

        super(options);

        this.offcanvasEl.addEventListener('hidden.bs.offcanvas', () => document.getElementById('search-query').blur());

        this.view = view;

        this.#initTypeahead();

        //this.query.subscribe(orgValue => {
        //    //this.suggestResult(null);
        //}, null, "beforeChange")
    }

    query = ko.observable("");
    suggestResult = ko.observable(null);

    isLoading = ko.observable(false);
    hasFocus = ko.observable(false);

    hasTerms = ko.pureComputed(() => !this.isLoading() && this.suggestResult() && this.suggestResult().Terms.length > 0);
    hasBrands = ko.pureComputed(() => !this.isLoading() && this.suggestResult() && this.suggestResult().BrandSuggests.length > 0);
    hasCategories = ko.pureComputed(() => !this.isLoading() && this.suggestResult() && this.suggestResult().CategorySuggests.length > 0);
    hasProducts = ko.pureComputed(() => !this.isLoading() && this.suggestResult() && this.suggestResult().ProductSuggests.length > 0);

    get #form() {
        return document.getElementById('store-search');
    }

    headerSearchCss = ko.pureComputed(() => {
        let classList = [];
        if (this.isOpen()) {
            classList.push("is--active");
        }

        return classList.join(' ');
    });

    openSearch() {
        this.show();
    }

    submit = () => this.#form.submit();

    #createBloodhound = (transform) => new Bloodhound({
        datumTokenizer: Bloodhound.tokenizers.obj.whitespace('value'),
        queryTokenizer: Bloodhound.tokenizers.whitespace,
        remote: {
            url: "%QUERY",
            wildcard: '%QUERY',
            transport: this.#getSearchResult,
            transform: transform,
            cache: false,
            rateLimitWait: 200
        }
    });

    #initTypeahead = () => {
        var options = {
            hint: true,
            highlight: false,
            minLength: 2,
            limit: 10,
            classNames: {
                wrapper: "search-suggest__wrapper flex-grow-1",
                menu: "suggest__menu",
                dataset: "suggest__dataset",
                open: "show",
                cursor: "item--selected",
                suggestion: "tt-selectable"
            },
            menu: $('#suggest-menu')
        };

        var dataSources = [{
            name: "product-suggests",
            node: "#tt-products",
            displayText: "Text",
            displayKey: "Value",
            limit: 50,
            source: this.#createBloodhound(data => data.ProductSuggests).ttAdapter(),
            templates: {
                header: data => ``,
                suggestion: data =>
                    `<a href="${data.Url}" title='${data.Text}' class="hover-trigger ${headerStyles.suggest.gridItemCss}" styles="${headerStyles.suggest.gridItemStyles}">
                        <div class="image-wrapper ratio ratio-1x1">
                            <img class="img-fluid bg-white object-fit-contain" src="${MediaApi.url(data.ImageUrl, { w: 160, h: 160 })}" alt='${data.Text}' width="160" height="160">
                        </div>
                        <div class="name group-name product-name flex-grow-1 lh-sm lines-truncate mt-2 ${headerStyles.suggest.gridItemNameCss}">
                            ${data.Text}
                        </div>
                    </a>`
            }
        },
        {
            name: "category-suggests",
            node: "#tt-categories",
            displayText: "Text",
            displayKey: "Value",
            limit: 50,
            source: this.#createBloodhound(data => data.CategorySuggests).ttAdapter(),
            templates: {
                suggestion: data => `<a href='${data.Url}' class='hover-trigger ${headerStyles.suggest.listItemCss}' style='${headerStyles.suggest.listItemStyles}'>${data.Text}</a>`
            }
        },
        {
            name: "brand-suggests",
            node: "#tt-brands",
            displayText: "Text",
            displayKey: "Value",
            limit: 50,
            source: this.#createBloodhound(data => data.BrandSuggests).ttAdapter(),
            templates: {
                suggestion: data => `<a href='${data.Url}' class='hover-trigger ${headerStyles.suggest.listItemCss}' style='${headerStyles.suggest.listItemStyles}'>${data.Text}</a>`
            }
        },
        {
            name: "term-suggests",
            node: "#tt-terms",
            displayText: "Text",
            displayKey: "Text",
            limit: 50,
            source: this.#createBloodhound(data => data.Terms).ttAdapter(),
            templates: {
                suggestion: data => `<a href='${data.Url}' class='hover-trigger ${headerStyles.suggest.listItemCss}' style='${headerStyles.suggest.listItemStyles}'>${data.Text}</a>`
            }
        }];

        var $el = $('#search-query');
        $el.typeahead(options, dataSources);

        $el.on('typeahead:select', (e, suggest) => {
            if (suggest.Url.length > 0) {
                window.location = suggest.Url;
            }
        });

        //document.querySelector(".search-suggest__wrapper").style.display = 'block';
    };

    #getSearchResult = async (options, onSuccess, onError) => {
        // Modify the options or replace the next line
        try {
            this.isLoading(true);
            const data = await SearchApi.suggestions(options.url);

            this.suggestResult(data);

            onSuccess(data);
        } catch (ex) {
            onError(ex);
        } finally {
            this.isLoading(false);
        }
    }

    onEnter = (model, e) => {
        e.keyCode === 13 && this.#form.submit();

        return true;
    }

    scan = () => {
        AppEvents.emit("scan", {
            success: (result) => {
                this.query(result);

                this.#form.submit();
            }
        });
    }
}